
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/home/welcome-section.kpa`,
      template: `<section class="welcome-section" id="welcome">
        <div class="wrapper">
            <div class="welcome-text">
                <hex-headline left text="Facility neu gedacht!"></hex-headline>
                <p>
                    Willkommen bei <b>FASE2</b> Facility Services - Ihrem neuen, zuverlässigen <b>Ansprechpartner</b> für alle Belange rund um Ihre Immobilie! 
                    Wir haben es uns zur <b>Vision</b> gemacht, eine neue Art der Facility zu etablieren. 
                    Mit unserer langjährigen <b>Expertise</b> in den Bereichen Gebäudereinigung und <b>Gebäudesanierung</b> 
                    bieten wir Ihnen einen kreativen und ganzheitlichen Service aus einer Hand.
                </p>
                <p>
                    Unsere <b>Mission</b> ist es, Immobilienbesitzern, <b>Verwaltern</b> und Mietern eine zentrale <b>Anlaufstelle</b> zu bieten, 
                    die sämtliche Serviceleistungen rund um die Immobilie abdeckt. Egal, ob es um die </b>Reinigung</b>, Renovierung, 
                    <b>Instandhaltung</b> oder Sanierung geht - mit <b>FASE2</b> haben Sie immer den richtigen Partner an Ihrer Seite.
                </p>
                <p>
                    Durch die langjährige <b>Erfahrung</b> von Hüseyin Sidar im Bereich Gebäudereinigung und die fachliche <b>Expertise</b> 
                    von Salvatore Laudani in der <b>Gebäudesanierung</b> erhalten Sie bei uns einen unverwechselbaren Mehrwert. 
                    Wir kombinieren traditionelles <b>Handwerk</b> mit modernen, effizienten <b>Lösungen</b>, 
                    um Ihre Immobilie nicht nur funktional, sondern auch <b>ästhetisch</b> und nachhaltig zu gestalten.
                </p>
                <p>
                    Unser <b>Ziel</b> ist es, Ihnen das Leben zu erleichtern und den <b>Wert</b> Ihrer Immobilie zu <b>steigern</b>, 
                    indem wir Ihnen maßgeschneiderte Lösungen anbieten - schnell, zuverlässig und stets mit dem Fokus auf <b>höchste Qualität</b>.
                </p>
                <p>
                    FASE2 steht für <b>Innovation</b>, Vertrauen und <b>höchste Professionalität</b> - lassen Sie uns gemeinsam Ihre Immobilie auf das <b>nächste Level</b> heben!
                </p>
                <button class="btn box-shadow">Jetzt Kontakt aufnehmen</button>
            </div>
            <div class="welcome-image box-shadow">
                <img src="/images/welcome.jpg" alt="Bild der Geschäftsführer"/>
            </div>
        </div>
    </section>`,
      style: `home-view .home-view > .wrapper > welcome-section {
  margin-top: 160px;
}

home-view .home-view > .wrapper > * > section.welcome-section {
  padding: 0;
  margin: 0;
}

welcome-section {
  position: relative;
  display: flex;
}
welcome-section .welcome-section {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom, transparent 0 30px, #f2f2f1 30px 100%);
}
welcome-section .welcome-section .wrapper {
  padding: 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 64px;
}
welcome-section .welcome-section .wrapper .welcome-text {
  display: flex;
  width: 100%;
  max-width: 705px;
  height: auto;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
welcome-section .welcome-section .wrapper .welcome-text p {
  margin-bottom: 64px;
}
welcome-section .welcome-section .wrapper .welcome-text p:has(+ p) {
  margin-bottom: 20px;
}
welcome-section .welcome-section .wrapper .welcome-text button {
  align-self: center;
}
welcome-section .welcome-section .wrapper .welcome-image {
  position: relative;
  overflow: hidden;
  width: calc(100% + 64px);
  height: auto;
  transform: translateX(-32px);
  margin-top: 32px;
}
welcome-section .welcome-section .wrapper .welcome-image img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  display: block;
}
@media (min-width: 859px) {
  welcome-section .welcome-section .wrapper {
    flex-flow: row nowrap;
    align-items: flex-start;
  }
  welcome-section .welcome-section .wrapper > div {
    min-width: calc(50% - 64px);
  }
  welcome-section .welcome-section .wrapper .welcome-image {
    border-radius: 8px;
    transform: translateX(0);
    margin-top: 96px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    events: [
        ['click', '.welcome-section button', function (event) {
                event.preventDefault();
                router.navigate('/home#kontakt');
            }],
    ],
};
 })()`
    };
  